import styled from '@emotion/styled';

import { ItemValue } from '../../styles';

export const ItemValueWrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
});

export const StyledItemValue = styled(ItemValue)((props) => ({
  width: 100,
  textAlign: 'right',
}));
